<div class="container" style="display:flex; height:100%; flex-direction:column; justify-content:space-between; padding: 24px;" *ngIf="screen == 'select'">

  <!-- Forgot username -->
  <div class="row justify-content-center">
    <h1 class="display-6" style="color: var(--elog-accent-text);" align="center">I forgot my username:</h1>
    <button mat-fab
            class="color-button-orange"
            type="button"
            align="center"
            (click)="screen = 'enter'; isUsername=true">
      <mat-icon>account_circle</mat-icon>
    </button>
  </div>

  <!-- Forgot password -->
  <div class="row justify-content-center">
    <h1 class="display-6" style="color: var(--elog-accent-text);" align="center">I forgot my password:</h1>
    <button mat-fab
            class="color-button-orange"
            type="button"
            align="center"
            (click)="screen = 'enter'; isUsername=false;">
      <mat-icon>
        password
      </mat-icon>
    </button>
  </div>

  <div class="row">
    <button mat-stroked-button
            class="color-button-blue"
            type="button"
            (click)="dialogRef.close()">
      Cancel
    </button>
  </div>


</div>




<div class="container" *ngIf="screen == 'enter'" style="display: flex; flex-direction: column; height: 100%; padding: 24px;">

  <div class="row justify-content-center">
    <h1 class="display-6" style="color: var(--elog-accent-text);" align="center">Enter your email to get your <span *ngIf="isUsername">username</span><span *ngIf="!isUsername">password reset code</span> </h1>
  </div>

  <div class="row">
    <mat-form-field appearance="fill">
      <mat-label>Email</mat-label>
      <input matInput type="text" [formControl]="email" (input)="_forbidSpaces()">
      <mat-error *ngIf="email.errors?.required">Required</mat-error>
      <mat-error *ngIf="email.errors?.email">Bad email format</mat-error>
    </mat-form-field>
  </div>

  <!-- Submit email to reset password -->
  <div class="row" style="margin-top: 15px;">
    <button mat-stroked-button
            class="color-button-orange"
            type="submit"
            (click)="goToReset()">
      Send!
    </button>
  </div>

  <!-- Do not submit email -->
  <div id="bottom-row" class="row" style="margin-top: auto;">
    <button mat-stroked-button
            class="color-button-blue"
            type="button"
            (click)="dialogRef.close()">
      Cancel
    </button>
  </div>

</div>


<div class="container" *ngIf="screen == 'reset'" style="display: flex; flex-direction: column; height: 100%; padding: 24px;">
  <div class="row justify-content-center">
    <h1 class="display-6" style="color: var(--elog-accent-text);" align="center">Check your email for a reset code and username. Enter them with your new password below to reset.</h1>
  </div>


  <div class="row">
    <mat-form-field appearance="fill">
      <mat-label>Username</mat-label>
      <input matInput type="text" [formControl]="username" (blur)="_trimUsername()">
      <mat-error *ngIf="username.invalid">Required</mat-error>
    </mat-form-field>

    <!-- Enter new password -->
    <mat-form-field appearance="fill">
      <mat-label>New Password</mat-label>
      <input matInput [type]="hide ? 'password' : 'text'" [formControl]="newPassword">
      <button mat-icon-button
              matSuffix
              type="button"
              (click)="hide = !hide">
        <mat-icon>
          {{hide ? 'visibility_off' : 'visibility'}}
        </mat-icon>
      </button>
      <mat-error *ngIf="newPassword.errors?.minlength">Minimum 8 characters required</mat-error>
      <mat-error *ngIf="newPassword.errors?.maxlength">Max 50 characters allowed</mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Reset Code</mat-label>
      <input matInput type="text" [formControl]="code" (input)="_forbidNonNumeric(code)">
      <mat-error *ngIf="code.invalid">Required</mat-error>
    </mat-form-field>
  </div>

  <!-- Change password -->
  <div class="row" style="margin-top: 15px;">
    <button mat-stroked-button
            class="color-button-orange"
            type="submit"
            (click)="sendRequest()">
      Change My Password
    </button>
  </div>

  <!-- Do not change password -->
  <div class="row" style="margin-top: auto;">
    <button mat-stroked-button
            class="color-button-blue"
            type="button"
            (click)="dialogRef.close()">
      Cancel
    </button>
  </div>


</div>
